import { render, staticRenderFns } from "./TotemJourneysTitle.vue?vue&type=template&id=5a7b87ae&scoped=true"
import script from "./TotemJourneysTitle.vue?vue&type=script&lang=js"
export * from "./TotemJourneysTitle.vue?vue&type=script&lang=js"
import style0 from "./TotemJourneysTitle.vue?vue&type=style&index=0&id=5a7b87ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a7b87ae",
  null
  
)

export default component.exports